import Icon from "@ant-design/icons/lib/components/Icon"
import { Menu } from "antd"
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom"
import { SystemConfigState, setTheme } from "../../../redux/systemConfigSlicer";
import { DesktopOutlined, FileImageOutlined, PieChartOutlined, QrcodeOutlined, UserOutlined, UserAddOutlined, ShopOutlined } from "@ant-design/icons";
import React from "react";
import { RootState } from '../../../redux/appState';

export { };

const PrivateMenu = () => {
  const location = useLocation();
  const theme = useSelector((state: { systemConfig: SystemConfigState }) => state.systemConfig.theme);
  const user = useSelector((state: RootState) => state.user.user);

  const menuItems: { [key: string]: '1' | '2' | '3' | '4' | '5' | '6' | '8' } = {
    '/': '1',
    '/home': '1',
    '/dashboard': '1',
    '/events': '2',
    '/users': '3',
    '/qrcode-generator': '4',
    '/placards': '5',
    '/dealers': '6',
    '/contracts': '8',
  };
  if (location.pathname.startsWith('/events/')) {
    menuItems[location.pathname] = '2';
  }
  const defaultSelectedKey = user.id !== '0' && user.profile_name !== 'Root'
    ? menuItems['/placards']
    : menuItems[location.pathname ?? '/'];
  const hiddenCondition = () => {
    return (user.id !== '0' && user.profile_name !== 'Root');
  }

  return (
    <Menu theme={theme} defaultSelectedKeys={[defaultSelectedKey]} mode="inline">
      <Menu.Item key="1">
        <PieChartOutlined />
        <span>Dashboard</span>
        <Link to="/dashboard" />
      </Menu.Item>
      {!hiddenCondition() ? (
        <>
          <Menu.Item key="2" hidden={hiddenCondition()}>
            <DesktopOutlined />
            <span>Events</span>
            <Link to="/events" />
          </Menu.Item>
          <Menu.Item key="3" hidden={hiddenCondition()}>
            <UserOutlined />
            <span>Users</span>
            <Link to="/users" />
          </Menu.Item>
          <Menu.Item key="4" hidden={hiddenCondition()}>
            <QrcodeOutlined />
            <span>QRcode generator</span>
            <Link to="/qrcode-generator" />
          </Menu.Item>
        </>
      ) : null}
      <Menu.Item key="5">
        <FileImageOutlined />
        <span>Placards</span>
        <Link to="/placards" />
      </Menu.Item>
      {!hiddenCondition() ? (
        <>
          <Menu.Item key="6" hidden={hiddenCondition()}>
            <UserOutlined />
            <span>Dealers</span>
            <Link to="/dealers" />
          </Menu.Item>
          <Menu.Item key="7" hidden={hiddenCondition()}>
            <UserAddOutlined />
            <span>Onboarding</span>
            <Link to="/onboarding" />
          </Menu.Item>
        </>
      ) : null
      }
      <Menu.Item key="7">
        <ShopOutlined />
        <span>Manage Inventory</span>
        <Link to="/inventoryMgmt" />
      </Menu.Item>
      <Menu.Item key="8" hidden={hiddenCondition()}>
        <UserOutlined />
        <span>Contracts</span>
        <Link to="/contracts" />
      </Menu.Item>
    </Menu>
  )
}

export default PrivateMenu;